@if (dataIsLoaded) {
  <div class="online-consultation-container">
    <div class="online-consultation-btn">
      <span class="online-consultation-icon">
        <img src="{{ data.imageUrl }}" />
      </span>
      <a class="online-consultation-font" href="{{ data.consultationUrl }}" target="_blank" [innerHTML]="data.title">
      </a>
    </div>
  </div>
}
